<template>
  <nav class="bg-white/90 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-gray-100">
    <div class="container mx-auto px-4 py-3">
      <div class="flex justify-between items-center">
        <!-- Logo -->
        <div class="flex items-center">
          <router-link to="/" class="flex items-center group">
            <div class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-lg group-hover:shadow-blue-200 transition-all duration-300">
              <span class="text-white font-bold text-xl">Y</span>
            </div>
            <span class="ml-2 text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-blue-600">Yisur</span>
          </router-link>
        </div>

        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center space-x-8">
          <router-link to="/" class="text-gray-600 hover:text-blue-600 font-medium transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-blue-600 after:transition-all hover:after:w-full">主页</router-link>
          <router-link to="/about" class="text-gray-600 hover:text-blue-600 font-medium transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-blue-600 after:transition-all hover:after:w-full">关于我们</router-link>
          <router-link to="/features" class="text-gray-600 hover:text-blue-600 font-medium transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-blue-600 after:transition-all hover:after:w-full">功能特点</router-link>
          <router-link to="/pricing" class="text-gray-600 hover:text-blue-600 font-medium transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-blue-600 after:transition-all hover:after:w-full">定价方案</router-link>
          <router-link to="/team" class="text-gray-600 hover:text-blue-600 font-medium transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-blue-600 after:transition-all hover:after:w-full">团队</router-link>
          <router-link to="/contact" class="text-gray-600 hover:text-blue-600 font-medium transition-colors relative after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-blue-600 after:transition-all hover:after:w-full">联系我们</router-link>
          
          <a href="#" @click.prevent="openModal" class="bg-blue-600 text-white px-5 py-2 rounded-full font-medium hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-200 transition-all transform hover:-translate-y-0.5">
            免费试用
          </a>
        </div>

        <!-- Mobile Menu Button -->
        <div class="md:hidden">
          <button @click="mobileMenuOpen = !mobileMenuOpen" class="text-gray-700 hover:text-blue-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path v-if="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Mobile Menu -->
      <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="transform -translate-y-2 opacity-0"
        enter-to-class="transform translate-y-0 opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="transform translate-y-0 opacity-100"
        leave-to-class="transform -translate-y-2 opacity-0"
      >
        <div v-if="mobileMenuOpen" class="md:hidden mt-4 pt-4 border-t border-gray-100">
          <div class="flex flex-col space-y-2">
            <router-link to="/" class="py-3 px-4 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600 font-medium">主页</router-link>
            <router-link to="/about" class="py-3 px-4 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600 font-medium">关于我们</router-link>
            <router-link to="/features" class="py-3 px-4 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600 font-medium">功能特点</router-link>
            <router-link to="/pricing" class="py-3 px-4 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600 font-medium">定价方案</router-link>
            <router-link to="/team" class="py-3 px-4 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600 font-medium">团队</router-link>
            <router-link to="/contact" class="py-3 px-4 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-600 font-medium">联系我们</router-link>
            <a href="#" @click.prevent="openModal" class="mt-2 py-3 px-4 rounded-lg bg-blue-600 text-white text-center font-medium hover:bg-blue-700">免费试用</a>
          </div>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script>
import { useVersionModal } from '@/composables/useVersionModal';

export default {
  name: 'Navbar',
  setup() {
    const { openModal } = useVersionModal();
    return { openModal };
  },
  data() {
    return {
      mobileMenuOpen: false,
      isOpen: false
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    }
  }
}
</script> 